import { api } from './api';
import type { AuthUser } from '../types/api';

export interface QrCreateResp {
  qrId: string;
  pollToken: string;
  expiresAt: string;
}
export type QrStatus = 'pending' | 'scanned' | 'consumed' | 'expired' | 'rejected';
export interface QrStatusResp {
  status: QrStatus;
  user?: AuthUser;
  accessToken?: string;
}
export type QrWarning = 'ANOMALOUS_REGION' | 'NEW_DEVICE';
export interface QrDeviceCard {
  region: string | null;
  browser: string;
  os: string;
  ip: string | null;
  time: string;
}
export interface QrScanResp {
  ok: true;
  device: QrDeviceCard;
  warnings: QrWarning[];
}

export const qrLoginApi = {
  create: () => api.post<QrCreateResp>('/auth/qr/create').then((r) => r.data),
  status: (qrId: string, pollToken: string) =>
    api.post<QrStatusResp>('/auth/qr/status', { qrId, pollToken }).then((r) => r.data),
  scan: (qrId: string) => api.post<QrScanResp>('/auth/qr/scan', { qrId }).then((r) => r.data),
  confirm: (qrId: string) => api.post<{ ok: true }>('/auth/qr/confirm', { qrId }).then((r) => r.data),
  cancel: (qrId: string) => api.post<{ ok: true }>('/auth/qr/cancel', { qrId }).then((r) => r.data),
};
